import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4476c7fe")
const _hoisted_1 = { class: "app-nav-footer" }
const _hoisted_2 = { class: "app-nav-footer-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/3 pl-2" }, null, -1)
const _hoisted_4 = { class: "w-1/3 flex justify-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/3 flex justify-end pr-2" }, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppNavToggle = _resolveComponent("AppNavToggle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_AppNavToggle, { darkModeBg: "700" })
      ]),
      _hoisted_5
    ])
  ]))
}